import {
  TResourceDetailColSpan,
  TResourceDetailItem,
} from '@/shared/components/ui/resource-detail/item/resource-detail-item.types';
import {
  COMPACT_ITEMS_PER_ROW,
  COMPACT_MIN_ITEMS,
} from '@/shared/components/ui/resource-detail/resource-detail.constants';

export const getResourceDetailItemSize = (
  itemsPerRow: number,
  colSpan?: TResourceDetailColSpan,
): number => {
  if (colSpan && colSpan > itemsPerRow) {
    throw new Error(
      `Column span must be less than or equal to items per row: ${itemsPerRow}`,
    );
  }

  return colSpan ?? 1;
};

export const getCompactItems = (
  items: TResourceDetailItem[],
): TResourceDetailItem[] => items.filter((item) => item.showOnlyOn !== 'full');

export const getFullItems = (
  items: TResourceDetailItem[],
): TResourceDetailItem[] =>
  items.filter((item) => item.showOnlyOn !== 'compact');

export const getCompactColumns = (items: TResourceDetailItem[]): number =>
  getCompactItems(items).reduce(
    (total, item) => total + (item.colSpan ?? 1),
    0,
  );

// Only enable compact mode when the full view is dense enough to be worth
// collapsing AND the compact items actually fit the row — otherwise
// ResourceDetailContent throws at render the moment the header is collapsed.
export const supportsCompact = (items: TResourceDetailItem[]): boolean =>
  getFullItems(items).length >= COMPACT_MIN_ITEMS &&
  getCompactColumns(items) <= COMPACT_ITEMS_PER_ROW;
